"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const b_1 = __importDefault(require("b_"));
const tooltip_1 = __importDefault(require("src/components/tooltip"));
const branding_1 = require("src/context/branding");
const getEmotionAssets_1 = __importDefault(require("./getEmotionAssets"));
const b = b_1.default.with('emotion');
const emotionsMap = {
    1: 'angry',
    2: 'sad',
    3: 'neutral',
    4: 'smile',
    5: 'laugh'
};
function QuestionEmotionOption(props) {
    const { theme, options = [], labels, handleClickOption } = props;
    const { tooltip: { widthType = 'narrow' } = {}, emotion: { preset = 'portal', selected: { label: { widthType: widthTypeChecked = 'narrow' } = {} } = {}, hover: { label: { widthType: widthTypeHover = 'narrow' } = {} } = {} } = {} } = (0, branding_1.useBrandingContext)() || {};
    const emotionAssets = (0, getEmotionAssets_1.default)(preset);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('options', { theme }), css: emotionAssets }, { children: options.map(({ id, checked }) => {
            const emotion = emotionsMap[id];
            const labelClasses = `${b('option', { [emotion]: true })} `;
            const label = labels[id - 1];
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('container', { checked }), onClick: handleClickOption, "data-value": id }, { children: theme === 'default' && labels ? ((0, jsx_runtime_1.jsxs)(tooltip_1.default, Object.assign({ text: label || '', widthType: widthType, widthTypeHover: widthTypeHover, widthTypeChecked: widthTypeChecked, checked: checked }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ className: b('wrapper', { theme }), "aria-pressed": Boolean(checked), "aria-label": label }, { children: (0, jsx_runtime_1.jsx)("div", { className: labelClasses }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('label', { overflow: true }) }, { children: label }))] }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper', { theme }) }, { children: (0, jsx_runtime_1.jsx)("div", { className: labelClasses }) }))) }), id));
        }) })));
}
exports.default = QuestionEmotionOption;
